import {
  IStat,
  IStatsList,
  StatsResolution,
} from 'components/lib/stats/constants';
import { forEach } from 'lodash';
import { Action, handleActions } from 'redux-actions';
import {
  STATS_SET_ALL_TIME,
  STATS_SET_DATA_DAYS,
  STATS_SET_DATA_WEEKS,
  STATS_SET_LOAD_ERROR,
  STATS_SET_LOAD_IS_BUSY,
  STATS_SET_TODAY,
  STATS_SET_TOTAL_DURATION,
} from './constants/ActionTypes';
import { IDurationTotal, IStatsLoadError, IStatsState } from './model';

const initialState: IStatsState = {
  all_time: null,
  data_load_state: {
    day_resolution_busy: false,
    day_resolution_loaded: false,
    week_resolution_busy: false,
    week_resolution_loaded: false,
  },
  days: {},
  stats_duration: null,
  today: null,
  weeks: {},
};

export default handleActions<
  IStatsState,
  IStat | IDurationTotal | StatsResolution | IStatsLoadError | IStatsList
>(
  {
    [STATS_SET_TODAY]: (
      state: IStatsState,
      action: Action<IStat>
    ): IStatsState => {
      const newToday: IStat | null = action.payload
        ? {
            seconds_read: action.payload.seconds_read,
            words_read: action.payload.words_read,
          }
        : null;
      return {
        ...state,
        today: newToday,
      };
    },

    [STATS_SET_TOTAL_DURATION]: (
      state: IStatsState,
      action: Action<IDurationTotal>
    ): IStatsState => {
      return {
        ...state,
        stats_duration: action.payload || null,
      };
    },

    [STATS_SET_ALL_TIME]: (
      state: IStatsState,
      action: Action<IStat>
    ): IStatsState => {
      const newAllTime: IStat | null = action.payload
        ? {
            seconds_read: action.payload.seconds_read,
            words_read: action.payload.words_read,
          }
        : null;
      return {
        ...state,
        all_time: newAllTime,
      };
    },

    [STATS_SET_LOAD_IS_BUSY]: (
      state: IStatsState,
      action: Action<StatsResolution>
    ): IStatsState => {
      return {
        ...state,
        data_load_state: {
          ...state.data_load_state,
          [`${action.payload}_resolution_busy`]: true,
        },
      };
    },

    [STATS_SET_LOAD_ERROR]: (
      state: IStatsState,
      action: Action<IStatsLoadError>
    ): IStatsState => {
      return {
        ...state,
        data_load_state: {
          ...state.data_load_state,
          [`${action.payload!.res}_resolution_busy`]: false,
        },
      };
    },

    [STATS_SET_DATA_DAYS]: (
      state: IStatsState,
      action: Action<IStatsList>
    ): IStatsState => {
      return {
        ...state,
        data_load_state: {
          ...state.data_load_state,
          day_resolution_busy: false,
          day_resolution_loaded: true,
        },
        days: normalizeStats(action.payload),
      };
    },

    [STATS_SET_DATA_WEEKS]: (
      state: IStatsState,
      action: Action<IStatsList>
    ): IStatsState => {
      return {
        ...state,
        data_load_state: {
          ...state.data_load_state,
          week_resolution_busy: false,
          week_resolution_loaded: true,
        },
        weeks: normalizeStats(action.payload),
      };
    },
  },
  initialState
);

function normalizeStats(list: IStatsList | undefined): IStatsList {
  const newList = {};
  if (!list) {
    return newList;
  }
  forEach(list, (item: IStat, key: string) => {
    newList[key] = {
      seconds_read: item.seconds_read,
      words_read: item.words_read,
    };
  });
  return newList;
}



// WEBPACK FOOTER //
// ./src/reading-stats/reducer.ts